import { Component, ElementRef, Inject, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CommonExternalModule } from '../../common/common-external-module';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { WebOrderLocationSetup } from '../../Model/web-order-location-setup';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ToastService } from '../../services/toast.service';
import { Subscription } from 'rxjs';
import { ContactService } from '../../services/contact.service';
import { WebUserInfo } from '../../data/web-user-info';
import { LocalStorageService } from '../../services/local-storage.service';
import { ApiFactoryEndPoints } from '../../common/api-factory-end-points';
import { ProductDeliveryAddressComponent } from '../../pages/product-delivery-address/product-delivery-address.component';
import { ProductService } from '../../services/product.service';
import { OrderSummary } from '../../Model/order-summary';
import { ProductOrderSummaryServiceService } from '../../services/product-order-summary-service.service';
import { Product } from '../../Model/product';
import { Router } from '@angular/router';
import { getWindow } from 'ssr-window';

@Component({
  selector: 'app-store-pickup-dialog',
  standalone: true,
  imports: [CommonExternalModule],
  templateUrl: './store-pickup-dialog.component.html',
  styleUrl: './store-pickup-dialog.component.css'
})
export class StorePickupDialogComponent implements OnInit, OnDestroy {

  currentUrl: string;
  selectedOption: string = '';
  url: string;

  createSetUpForm: UntypedFormGroup;
  pincode: number;
  locationSetupList: WebOrderLocationSetup[] = [];
  orderSummary: OrderSummary = new OrderSummary();
  availableOptions = ['delivery'];

  showToast: boolean = false;
  showClickButton: boolean = true;
  showSubmitBtn: boolean = false;
  selectedIndex: number = null;

  //For Google Map
  searchInput: string = '';
  newDeliveryDetails: boolean = true;
  latitudeMap: number;
  longitudeMap: number;
  zoom: number = 10;

  addressMap: string;
  private geoCoder;
  private googleMapInitialized = false;
  @ViewChild("search") public searchElementRef: ElementRef;

  center: google.maps.LatLngLiteral = { lat: 28.6139, lng: 77.2090 };
  markerPosition: google.maps.LatLngLiteral = { lat: 28.6139, lng: 77.2090 };
  markerOptions: google.maps.MarkerOptions = {
    draggable: true
  };

  private onLocationDetailsSubscription: Subscription;
  private saveWebUserInfoSubscription: Subscription;
  private onDeliveryLocClickSubscription: Subscription;

  constructor(
    private formBuilder: UntypedFormBuilder,
    public dialogRef: MatDialogRef<StorePickupDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private localStorage: LocalStorageService,
    private apiFactory: ApiFactoryEndPoints,
    private toastService: ToastService,
    // private productService: ProductService,
    private navRoute: Router,
    // private commonService: CommonService,
    private contactService: ContactService,
    // public dialog: MatDialog,
    // private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private productService: ProductService,
    private productOrderSummaryService: ProductOrderSummaryServiceService,
  ) {
    if (dialogData && dialogData.type) {
      this.selectedOption = dialogData.type;
    }
  }

  ngOnInit(): void {
    // this.url = getWindow().location.hostname;
    this.url = window.location.host.replace(':', '');
    this.currentUrl = this.navRoute.url.replace("/", "");
    // this.googleCustomer = JSON.parse(this.localStorage.getItem("google_loggedIn_details"));
    // this.deliveryType = JSON.parse(this.localStorage.getItem("delivery_type"));
    this.availableOptions = ['delivery']; // Set available options based on your conditions

    // Check if only one option is available
    if (this.availableOptions.length === 1 && !this.selectedOption) {
      this.selectedOption = this.availableOptions[0];
    }
    // // this.storeLocation = JSON.parse(this.localStorage.getItem("pickup_location"));
    // this.setCurrentLocationStore();
    // // this.getStoreLocationList();
    this.onCreateSetUp();
  }

  ngAfterViewInit(): void {
    console.log(this.selectedOption)
    if (this.selectedOption === 'delivery') {
      this.initMapIfNeeded();
    }
  }

  ngOnDestroy(): void {

  }

  onCreateSetUp() {
    this.createSetUpForm = this.formBuilder.group({
      pincode: ["", [Validators.required, Validators.pattern("^[1-9][0-9]{5}$")],],
    });
  }

  initMapIfNeeded(): void {
    console.log(this.googleMapInitialized)
    console.log(this.searchElementRef)
    if (!this.googleMapInitialized && this.searchElementRef) {
      this.getGoogleMap();
      this.googleMapInitialized = true;
    }
  }

  //Map
  // getGoogleMap() {
  //   this.mapsAPILoader.load().then(() => {
  //     this.setCurrentLocationPin();
  //     this.geoCoder = new google.maps.Geocoder();

  //     const autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement);
  //     autocomplete.addListener("place_changed", () => {
  //       this.ngZone.run(() => {
  //         const place = autocomplete.getPlace();
  //         if (!place.geometry) return;

  //         this.latitudeMap = place.geometry.location.lat();
  //         this.longitudeMap = place.geometry.location.lng();
  //         this.zoom = 12;

  //         this.getAddress(this.latitudeMap, this.longitudeMap);
  //       });
  //     });
  //   });
  // }

  getGoogleMap() {
    this.setCurrentLocationPin();
    this.geoCoder = new google.maps.Geocoder();

    const autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement);
    autocomplete.addListener('place_changed', () => {
      this.ngZone.run(() => {
        const place = autocomplete.getPlace();
        if (!place.geometry || !place.geometry.location) {
          return;
        }

        this.latitudeMap = place.geometry.location.lat();
        this.longitudeMap = place.geometry.location.lng();
        this.zoom = 15;

        this.center = {
          lat: this.latitudeMap,
          lng: this.longitudeMap
        };

        this.markerPosition = {
          lat: this.latitudeMap,
          lng: this.longitudeMap
        };


        this.getAddress(this.latitudeMap, this.longitudeMap);
      });
    });
  }

  private setCurrentLocationPin() {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.latitudeMap = position.coords.latitude;
        this.longitudeMap = position.coords.longitude;
        this.zoom = 12;
        // this.getAddress(this.latitudeMap, this.longitudeMap);
      });
    }
  }

  getAddress(latitude: number, longitude: number) {
    this.toastService.clearAllToast();
    this.geoCoder.geocode({ location: { lat: latitude, lng: longitude } }, (results, status) => {
      if (status === "OK" && results[0]) {
        this.zoom = 12;
        this.addressMap = results[0].formatted_address;

        const addressComponents = results[0].address_components;
        console.log(addressComponents);
        const pincodeComponent = addressComponents.find(c => c.types.includes('postal_code'));
        console.log(pincodeComponent);
        if (pincodeComponent) {
          this.pincode = pincodeComponent.long_name;
          this.createSetUpForm.patchValue({ pincode: this.pincode });
          this.choosePincode();
        } else {
          this.toastService.showErrorToast("Pincode not found.");
          this.clearSearch();
        }
      } else {
        this.toastService.showErrorToast("Geocoder failed due to: " + status);
      }
    });
  }

  choosePincode() {
    this.pincode = this.createSetUpForm.get("pincode").value;
    this.showToast = false;

    if (this.pincode.toString().length === 6) {
      this.onLocationDetailsSubscription = this.contactService.getLocationDetailsByPincodeAndlatlng(this.pincode, this.url, this.latitudeMap, this.longitudeMap).subscribe((data) => {
        console.log(data);
        if (data.length > 0) {
          this.showClickButton = false;
          this.showSubmitBtn = true;
          this.showToast = false;
          this.locationSetupList = data;

          this.locationSetupList.forEach((element) => {
            if (element.address.length > 40) {
              let firstAdd: string = "";
              const adds = element.address.split(",");
              if (adds.length > 0) {
                for (let i = 0; i < adds.length; i++) {
                  if (firstAdd.length + adds[i].length < 40) {
                    firstAdd += adds[i] + ", ";
                  }
                }
              }
              if (firstAdd.length > 0) {
                element.address1 = firstAdd;
                element.address2 = element.address.substring(
                  firstAdd.length - 1,
                  element.address.length
                );
              }
            } else {
              element.address1 = element.address;
            }
          });
          if (this.locationSetupList.length == 1) {
            this.onSelectLocation(0);
          }
        } else {
          this.showClickButton = true;
          this.showToast = true;
          this.locationSetupList = [];
          this.selectedIndex = null;
          this.saveWebUserInfo();
        }
      });
    }
  }

  saveWebUserInfo() {
    const localWebUserInfo: WebUserInfo = JSON.parse(this.localStorage.getItem("web_user_info"));
    const blockedIps = ['182.79.71.219', '182.79.71.218'];
    if (localWebUserInfo && localWebUserInfo.clientIp && !blockedIps.includes(localWebUserInfo.clientIp)) {
      localWebUserInfo.searchedPinCodeArea = this.pincode.toString();

      this.saveWebUserInfoSubscription = this.contactService.saveWebUserInfo(this.apiFactory.insertWebUserInfo, localWebUserInfo).subscribe((data) => {
        if (data) {
        }
      });
    }
  }

  onSearchInput(value: string) {
    this.searchInput = value;
  }

  clearSearch() {
    this.searchInput = '';
    if (this.searchElementRef?.nativeElement) {
      this.searchElementRef.nativeElement.value = '';
    }
    this.locationSetupList = [];
    this.showToast = false;
    this.showClickButton = true;
    this.googleMapInitialized = false;
  }

  fetchCurrentLoc() {
    if (!("geolocation" in navigator)) {
      this.toastService.showErrorToast("Geolocation not supported");
      return;
    }

    this.toastService.showWarningToast("Fetching current location...");

    let watchId = navigator.geolocation.watchPosition(
      (position) => {
        console.log("Live location fetched: ", position);

        this.latitudeMap = position.coords.latitude;
        this.longitudeMap = position.coords.longitude;
        this.zoom = 12;

        this.createSetUpForm.patchValue({
          latitude: this.latitudeMap,
          longitude: this.longitudeMap,
        });

        this.getAddress(this.latitudeMap, this.longitudeMap);

        // Stop watching after first successful fetch
        navigator.geolocation.clearWatch(watchId);
      },
      (error) => {
        console.error("Geolocation error: ", error);
        let message = "";

        switch (error.code) {
          case error.PERMISSION_DENIED:
            message = "Permission denied. Enable location.";
            break;
          case error.POSITION_UNAVAILABLE:
            message = "Location unavailable. Try again.";
            break;
          case error.TIMEOUT:
            message = "Request timed out.";
            break;
          default:
            message = "Unknown location error.";
        }

        this.toastService.showErrorToast(message);
        navigator.geolocation.clearWatch(watchId);
      },
      {
        enableHighAccuracy: true,
        timeout: 20000,
        maximumAge: 0
      }
    );
  }

  markerDragEnd(event: any) {
    this.latitudeMap = event.latLng.lat();
    this.longitudeMap = event.latLng.lng();
    this.getAddress(this.latitudeMap, this.longitudeMap);

    this.createSetUpForm.patchValue({
      latitude: this.latitudeMap,
      longitude: this.longitudeMap,
    });
  }

  onSelectLocation(index: number) {
    this.selectedIndex = index;
  }

  onContinueClick(selectedOption: string) {
    if (selectedOption == 'storePickup') {
      // if (!this.storeLocation) {
      //   this.toastService.showErrorToast('Select Location');
      //   return;
      // }

      // this.localStorage.setItem("delivery_type", JSON.stringify(selectedOption));
      // this.localStorage.setItem("location_code", JSON.stringify(this.storeLocation.locationCode));
      // this.localStorage.setItem("company_code", JSON.stringify(this.storeLocation.companyCode));
      // this.localStorage.setItem("state_code", JSON.stringify(this.storeLocation.stateCode));
      // this.localStorage.setItem("min_selflife", JSON.stringify(this.storeLocation.minSelfLife));
      // this.localStorage.setItem("parent_location_code", JSON.stringify(this.storeLocation.parentLocationCode));
      // this.localStorage.setItem("pickup_location", JSON.stringify(this.storeLocation));

      // this.clearSearch();
      // this.dialogRef.close('storePickup');
    } else if (selectedOption == 'delivery') {
      this.onDeliveryLocClick(this.locationSetupList[this.selectedIndex]);
      // this.dialogRef.close('delivery');
      // this.storeLocation = null;
    } else {
      this.toastService.showSuccessToast("Pickup or Delivery");
    }
  }

  onDeliveryLocClick(locData: WebOrderLocationSetup) {
    console.log(locData);
    if (!locData || !this.latitudeMap || !this.longitudeMap || !this.pincode) {
      this.toastService.showErrorToast("Please select a valid location");
      return;
    }

    this.storeLocationData(locData);

    this.pincode = this.createSetUpForm.get("pincode").value;
    this.onDeliveryLocClickSubscription = this.productService.checkPincode(this.apiFactory.checkPincode, locData.pincode, this.url)
      .subscribe((isValidPincode) => {
        if (isValidPincode) {
          this.handleValidPincode(locData);
        } else {
          this.toastService.showErrorToast("Invalid Pincode");
          this.createSetUpForm.patchValue({ pincode: "" });
        }
      });
  }

  private storeLocationData(locData: WebOrderLocationSetup) {
    this.localStorage.setItem("location_code", JSON.stringify(locData.locationCode));
    this.localStorage.setItem("state_code", JSON.stringify(locData.stateCode));
    this.localStorage.setItem("company_code", JSON.stringify(locData.companyCode));
    this.localStorage.setItem("parent_location_code", JSON.stringify(locData.parentLocationCode));
    this.localStorage.setItem("delivery_location", JSON.stringify(locData));
  }

  private handleValidPincode(locData: WebOrderLocationSetup) {
    // Remove old pincode & minSelfLife data from localStorage
    this.localStorage.removeItem("pincode_item");
    this.localStorage.removeItem("min_selflife");

    // Update order summary
    this.orderSummary.pincode = locData.pincode;
    this.orderSummary.product = this.dialogData?.productValue;
    this.productService.setOrderSummary(this.orderSummary);
    this.productService.setPincode(locData.pincode);

    // Save new pincode & minSelfLife data to localStorage
    this.localStorage.setItem("delivery_type", JSON.stringify('delivery'));
    this.localStorage.setItem("pincode_item", JSON.stringify(locData.pincode));
    this.localStorage.setItem("min_selflife", JSON.stringify(locData.minSelfLife));
    this.localStorage.setDeliveryDetails({
      pincode: this.pincode,
      latitude: this.latitudeMap,
      longitude: this.longitudeMap
    });


    const cartProducts: Product[] = JSON.parse(this.localStorage.getItem("avct_item")) || [];

    if (cartProducts.length > 0) {
      this.dialogRef.close('delivery');
    } else {
      this.navRoute.navigate([this.currentUrl]);
      this.dialogRef.close('delivery');
    }
  }
}